<style scoped>
.pub-list .el-table__header-wrapper {
    display: block !important;
    overflow: initial !important;
}

.el-main {}

.el-button--text {
    background: white;
}

/* .el-button--text:hover {
    background: white;
} */

.notes-box {
    box-shadow: 0 1px 7px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 6px 6px 6px 6px;
    border-radius: 50%;
}

/* .notes-box:hover {
    box-shadow: 0 1px 7px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 6px 6px 6px 6px;
    border-radius: 50%;
} */

.box-header .box-title {
    display: inline-block;
    font-size: 15px;
    padding: 10px;
    line-height: 1;
    color: black;
}

.content-wrapper .content {
    padding-top: 95px !important;
}

.notes-domain {
    line-height: 1;
    display: block;
}

.slide-fade-enter-active {
    transition: all 3s ease;
}

.slide-fade-leave-active {
    transition: all 8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
}

.shadowBox {
    box-shadow: 0 1px 7px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 10px;
}


.round {
    border-radius: 50%;
}

.el-button--primary>span>a {
    color: #fff;
}

.domain-name {
    display: block;
    line-height: 1;
    font-weight: bold;
    color: #444;
    text-align: left;
}

.el-button--info {
    box-shadow: 0 1px 7px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.el-button--info:hover,.el-button--info:focus {
    box-shadow: 0 1px 40px rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .04) !important;
    padding: 10px;
    background-color: white;
    color: black;
}

.el-table {
    font-size: 13.5px;
}

.publisher-name {
    color: #444;
    font-size: 10px;
    float: left;
    margin-left: 0px;
    padding: 0 10px;
    border-radius: 20px;
    line-height: 1;
    margin-top: 6px;
    text-transform: uppercase;
}

.dfp-network-alias {
    color: #444;
    font-size: 10px;
    float: left;
    margin-left: 0px;
    padding: 0 10px;
    border-radius: 20px;
    line-height: 1;
    margin-top: 6px;
    text-transform: uppercase;
}

.bucket-list {
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    white-space: nowrap;
    overflow: auto;
}

.bucket-list li {
    float: left;
    margin-right: 10px;
}

.bucket-list li:last-child {
    margin-right: 0
}

.forcontract {
    padding: 16px 18px;
    /* background: #6767e2e0;*/
    /* color: white;  */
}

.report-upload-popup button.el-dialog__headerbtn {
    z-index: 2;
}

.colorbtn {
    color: #fff;
    background-color: #67c23a;
    border-color: #67c23a;
    border-radius: 4px;
    padding: 10px 27px;
}

.buckets {
    overflow: auto;
}
</style>
<template>
<div class="content-wrapper">
    <section class="content">
        <div class="box">
            <div class="box-header with-border">
                <h1 class="box-title">Domain</h1>
            </div>
            <div class="box-header with-border">
                <h2 class="box-title">Search</h2>
                <el-input type="text" class="col-lg-3" v-model="searchvalue" @keyup.enter.native="filterByEachInput" placeholder="Search Any Domain By Name"></el-input>
            </div>

            <div class="box-body pub-list">
                <router-link to="/admin/bidders/create-domain" class="el-button el-button--info pull-right">
                    <i class="el-icon-plus el-icon-left"></i>
						Create Domain
			    </router-link>
                <router-link to="/admin/bidders/create-bulk-domain" class="el-button el-button--info pull-right" style="margin-right:1rem;">
                    <i class="el-icon-plus el-icon-left"></i>
                        Create Domains
                </router-link>
                <router-link to="/admin/bidders/create-bulk-line-item" class="el-button el-button--info pull-right" style="margin-right:1rem;">
                    <i class="el-icon-plus el-icon-left"></i>
                        Bulk Line Item Creation
                </router-link>
                <el-table height="400" v-loading="loading" :data="publisher" style="width: 100%;border-spacing: 0;">
					

                    <el-table-column label="Domain Name" prop="name" width="700">
                        <template slot-scope="props">
							<router-link :to="`${'/admin/lineitems/'+ props.row.id}` ">
                           		 <span class="domain-name">{{`${props.row.url}`}}</span>
							</router-link>
                        </template>
                    </el-table-column>

                    <el-table-column>
							<template slot-scope="props">
                                <el-tooltip content="Edit Domain" placement="bottom">
                                    <router-link  :to="`${ '/admin/bidders/domain/'+ props.row.id}`">
                                        <el-button icon="el-icon-edit-outline" class = "notes-box" type="text" size="small"></el-button>
                                    </router-link>
                                </el-tooltip>
							</template>
						</el-table-column>
                   

                </el-table>

              

                <el-pagination style="text-align:center;margin-top:30px" @current-change="handleCurrentChange" :page-size="offset" :pager-count="20" layout="prev, pager, next" :total="total_pages" :current-page.sync="currentPage">
                </el-pagination>

            </div>

        </div>
    </section>
    <transition>
        <router-view></router-view>
    </transition>
</div>
</template>

<script>
import axios from 'axios';
import LetterAvatar from '../../../../static/plugins/letterAvatar.js'

export default {
    data() {
        return {
            publisher: [],
            bottom: false,
            frmdata: new FormData(),
            taxFile: '',
            downloadurl: "",
            dialogVisible: false,
            UploadScreenVisible: false,
            publisherid: '',
            uploading: false,
            publisherinitiateid: '',
            pubidcontract: '',
            contractvisiblescreen: false,
            pubidforemail: '',
            searchvalue: '',
            contract: '',
            currentPage: 1,
            total_pages: 0,
            offset: 20,
            issearch:false,

        };
    },
    created: function () {
        this.loadPublishers();
    },
   
    methods: {
        handleCurrentChange(val) {
          
            this.currentPage = val;
            if(this.issearch){
                this.filterByEachInput();
            }
            else{
            this.loadPublishers(val);
            }

        },
        filterByEachInput() {

            this.issearch = true;

            if (this.searchvalue.length == 0) {
                this.issearch = false;
                 const apis = BASE_URL + `bidder/v1/domain-list/?page=${this.currentPage}&offset=${this.offset}`;
                axios.get(apis)
                    .then(response => {
                        this.publisher = [];
                        var dt = response.data.data;
                        console.log(dt,response)
                        this.publisher.push(...dt);
                        this.total_pages = response.data.total;
                    });

                return;
            }
            
            var api = BASE_URL + `bidder/v1/domain-search/?query=${this.searchvalue}&&page=${this.currentPage}&&offset=${this.offset}`

            axios.get(api)
                .then(response => {
                    var data = response.data.data;
                    this.publisher = [];
                    this.publisher.push(...data);
                    this.total_pages = response.data.total;
                   
                });

        },
       
       
       
       
      
        loadPublishers(pageNum) {
           
            if (pageNum == undefined) {
                pageNum = 1;
            }
              const api1 = BASE_URL + `bidder/v1/domain-list/?page=${pageNum}&&offset=${this.offset}`;
            axios.get(api1).then(response => {
               var data=response.data.data;
                this.publisher = [];
                this.publisher.push(...data);

                var totalpg = response.data.total;
                this.total_pages = totalpg;

                console.log("response of api1",response.data);

            })

           

        },

    }
};
</script>



// WEBPACK FOOTER //
// Bidders.vue?60c880a8